import React from "react";
import {getFuelEventType} from "./fuelStatus";

const isFuelEventType = (data: any, eventType: number) =>
  getFuelEventType(data?.type) === eventType;

export const formatFuelCurrentLevel = (data: any, uid: string) => {
  if (!isFuelEventType(data, 2)) {
    return;
  }

  const value = data?.[uid];

  if (value === null || value === undefined || value === "") {
    return;
  }

  const numericValue = Number(String(value).replace(/[^\d.-]/g, ""));

  if (!Number.isFinite(numericValue)) {
    return String(value);
  }

  const level =
    Number.isInteger(numericValue) && numericValue >= 0 && numericValue < 10
      ? String(numericValue).padStart(2, "0")
      : String(numericValue);

  return `${level}L Remaining`;
};

const getFuelLevelProgress = (data: any, uid: string) => {
  const currentFuelLevel = Number(
    String(data?.[uid] ?? data?.currentFuelLevel).replace(/[^\d.-]/g, "")
  );

  const fuelCapacity = Number(
    String(data?.fuelCapacity).replace(/[^\d.-]/g, "")
  );

  if (
    Number.isFinite(currentFuelLevel) &&
    Number.isFinite(fuelCapacity) &&
    fuelCapacity > 0
  ) {
    return Math.max(0, Math.min(100, (currentFuelLevel / fuelCapacity) * 100));
  }

  return 0;
};

export const NeoFuelCurrentLevel: React.FC<any> = ({data, uid}) => {
  const currentFuelLevel = formatFuelCurrentLevel(data, uid);

  if (!currentFuelLevel) {
    return <>{currentFuelLevel}</>;
  }

  return (
    <div className="flex w-28 flex-col gap-1">
      <span className="text-sm text-gray-500">{currentFuelLevel}</span>

      <div className="h-1.5 w-24 overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-[#F28A03]"
          style={{width: `${getFuelLevelProgress(data, uid)}%`}}
        />
      </div>
    </div>
  );
};
